export const CREATE_APD_FAILURE = 'CREATE_APD_FAILURE';
export const CREATE_APD_REQUEST = 'CREATE_APD_REQUEST';
export const CREATE_APD_SUCCESS = 'CREATE_APD_SUCCESS';

export const DELETE_APD_FAILURE = 'DELETE_APD_FAILURE';
export const DELETE_APD_REQUEST = 'DELETE_APD_REQUEST';
export const DELETE_APD_SUCCESS = 'DELETE_APD_SUCCESS';

export const FETCH_ALL_APDS_FAILURE = 'FETCH_ALL_APDS_FAILURE';
export const FETCH_ALL_APDS_REQUEST = 'FETCH_ALL_APDS_REQUEST';
export const FETCH_ALL_APDS_SUCCESS = 'FETCH_ALL_APDS_SUCCESS';

export const NAVIGATION_SCROLL_TO_WAYPOINT = 'NAVIGATION_SCROLL_TO_WAYPOINT';

export const PRINT_APD = 'PRINT_APD';

export const RESET = 'RESET';

export const SAVE_APD_FAILURE = 'SAVE_APD_FAILURE';
export const SAVE_APD_REQUEST = 'SAVE_APD_REQUEST';
export const SAVE_APD_SUCCESS = 'SAVE_APD_SUCCESS';

export const SELECT_APD_SUCCESS = 'SELECT_APD_SUCCESS';
export const SELECT_APD_REQUEST = 'SELECT_APD_REQUEST';
export const SELECT_APD_FAILURE = 'SELECT_APD_FAILURE';

export const SET_APD_TO_SELECT_ON_LOAD = 'SET_APD_TO_SELECT_ON_LOAD';

export const ADMIN_CHECK_TOGGLE = 'ADMIN_CHECK_TOGGLE';
export const ADMIN_CHECK_COLLAPSE_TOGGLE = 'ADMIN_CHECK_COLLAPSE_TOGGLE';
export const ADMIN_CHECK_COMPLETE_TOGGLE = 'ADMIN_CHECK_COMPLETE_TOGGLE';
